/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { object, string, func } from 'prop-types';
import IconClose from '@material-ui/icons/Close';

const styles = (theme) => ({
    modalTopBar: {
        maxHeight: 40,
        display: 'flex',
        justifyContent: 'space-between',
        boxShadow: `0px 4px 5px 0px ${theme.palette.cgc?.grey || 'rgba(0,0,0,0.2)'}`,
    },
    modalTitle: {
        paddingLeft: '15px',
        fontSize: '20px',
        color: theme.palette.cgc?.bgTextOverlay1 || 'rgba(0,0,0,0.6)',
        fontWeight: 900,
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
        },
    },
    iconHeader: {
        height: 40,
        width: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: 10,
    },

});
const CGCModalHeader = ({ classes, closeModal, headerTitle }) => (
    <Grid container className={classes.modalTopBar}>
        <Grid item xs={10} className={classes.modalTitle}>
            {headerTitle}
        </Grid>
        <Grid
            item
            xs={2}
            className={classes.iconHeader}
        >
            <div
                id="cgcmodal-close-btn"
                data-testid="cgcmodal-close-btn"
                onClick={() => closeModal(false)}
                onKeyDown={() => { }}
                role="button"
                tabIndex={-1}
            >
                <IconClose className={classes.icon} titleAccess="Close" />
            </div>
        </Grid>
    </Grid>
);
CGCModalHeader.propTypes = {
    classes: object.isRequired,
    headerTitle: string.isRequired,
    closeModal: func.isRequired,
};
export default withStyles(styles)(CGCModalHeader);
